import request from "@/utils/request";

export function getListType(data) {
  return request({
    url: `/recommend-sys/powerType?language=${data.language}`,
    method: "get",
  });
}

export function getListDevice(data) {
  return request({
    url: `/recommend-sys/device?language=${data.language}`,
    method: "get",
  });
}
// 计算获取产品
export function getCalc(data) {
  return request({
    url: "/recommend-sys/calc",
    method: "post",
	data:data
  });
}
// 计算获取产品语言
export function getCalclanguage(data) {
  return request({
    url: "/recommend-sys/language",
	method: "get"
  });
}